"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17;

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonLink = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = __importDefault(require("react"));

var Link_1 = require("./Link");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var styled_1 = __importDefault(require("@emotion/styled"));

var frontend_typography_1 = require("@ryerson/frontend.typography");

var react_2 = require("@emotion/react");

var ButtonLinkContainer = styled_1.default.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\twidth: auto;\n\tdisplay: inline-block;\n\theight: auto;\n\tcursor: pointer;\n"])));
var ButtonLinkIcon = styled_1.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\twidth: 40px;\n\theight: 40px;\n\tline-height: 47px;\n\ttext-align: center;\n\tborder-radius: 40px;\n\t", "\n"])), function (props) {
  var theme = props.theme;
  return (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t"])), theme.colors.primary.primaryBrand);
});
var SmallButtonLinkIcon = styled_1.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\twidth: 24px;\n\theight: 24px;\n\tline-height: 25px;\n\ttext-align: center;\n\tborder-radius: 24px;\n\t", "\n"])), function (props) {
  var theme = props.theme;
  return (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\t\t\tbackground-color: ", ";\n\t\t"])), theme.colors.primary.primaryBrand);
});
var ButtonLinkText = styled_1.default.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tline-height: 16px !important;\n\theight: auto;\n"])));

var ButtonLink = function ButtonLink(_ref) {
  var label = _ref.label,
      _ref$linkType = _ref.linkType,
      linkType = _ref$linkType === void 0 ? "internal" : _ref$linkType,
      _ref$gatsby = _ref.gatsby,
      gatsby = _ref$gatsby === void 0 ? false : _ref$gatsby,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? "primary" : _ref$type,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      _ref$orientation = _ref.orientation,
      orientation = _ref$orientation === void 0 ? "left" : _ref$orientation,
      to = _ref.to;

  var _ref2 = (0, frontend_theme_1.useTheme)(),
      theme = _ref2.theme;

  var icon = "chevron-right";
  if (linkType === "external") icon = "arrow-up-right";else if (linkType === "help") icon = "question-mark";

  var LinkIcon = function LinkIcon() {
    switch (size) {
      case "sm":
        return (0, jsx_runtime_1.jsx)(SmallButtonLinkIcon, {
          css: orientation === "left" ? (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tmargin-right: 10px;\n\t\t\t\t\t\t\t\t  "]))) : (0, react_2.css)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tmargin-left: 10px;\n\t\t\t\t\t\t\t\t  "]))),
          theme: theme,
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: icon,
            size: "xs",
            color: theme.colors.primary.white,
            circled: false,
            css: (0, react_2.css)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t"])))
          })
        });

      case "md":
        return (0, jsx_runtime_1.jsx)(ButtonLinkIcon, {
          css: orientation === "left" ? (0, react_2.css)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tmargin-right: 20px;\n\t\t\t\t\t\t\t\t  "]))) : (0, react_2.css)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t\t\t  "]))),
          theme: theme,
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: icon,
            size: "sm",
            color: theme.colors.primary.white,
            circled: false,
            css: (0, react_2.css)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t\t"])))
          })
        });

      default:
        (0, jsx_runtime_1.jsx)(ButtonLinkIcon, {
          css: orientation === "left" ? (0, react_2.css)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tmargin-right: 20px;\n\t\t\t\t\t\t\t  "]))) : (0, react_2.css)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\t\t\tmargin-left: 20px;\n\t\t\t\t\t\t\t  "]))),
          theme: theme,
          children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
            icon: icon,
            size: "sm",
            color: theme.colors.primary.white,
            circled: false,
            css: (0, react_2.css)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n\t\t\t\t\t\t\tcursor: pointer;\n\t\t\t\t\t\t"])))
          })
        });
    }
  };

  return (0, jsx_runtime_1.jsx)(Link_1.Link, {
    to: to,
    target: linkType === "external" ? "_blank" : "_self",
    gatsby: gatsby,
    children: (0, jsx_runtime_1.jsxs)(ButtonLinkContainer, {
      css: (0, react_2.css)(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n\t\t\t\t\ttext-align: ", ";\n\t\t\t\t"])), orientation === "left" || orientation === "right" ? orientation : "center"),
      children: [orientation === "left" ? (0, jsx_runtime_1.jsx)(LinkIcon, {}) : (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {}), (0, jsx_runtime_1.jsx)(ButtonLinkText, {
        css: (0, react_2.css)(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n\t\t\t\t\t\twidth: ", ";\n\t\t\t\t\t"])), size === "sm" ? "calc( 100% - 34px );" : "calc( 100% - 60px )"),
        children: Array.isArray(label) ? label.map(function (individualLabel, index) {
          return (0, jsx_runtime_1.jsxs)(react_1.default.Fragment, {
            children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              size: "sm",
              weight: "bold",
              color: theme.colors[type].header,
              variant: "span",
              children: individualLabel
            }), index === label.length - 1 ? (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {}) : (0, jsx_runtime_1.jsx)("br", {})]
          }, index);
        }) : (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
          size: "sm",
          weight: "bold",
          color: theme.colors[type].header,
          variant: "span",
          children: label
        })
      }), orientation === "right" ? (0, jsx_runtime_1.jsx)(LinkIcon, {}) : (0, jsx_runtime_1.jsx)(react_1.default.Fragment, {})]
    })
  });
};

exports.ButtonLink = ButtonLink;